import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';

import Header from './Header';
import EmptyMyReward from './EmptyMyReward';
import Loading from './Loading'
import { getCodeLists, trackSharePop } from '../../Utils/blogs';
import {GIFT_CARD_SVG, RIGHT_SVG} from '../staticTypes';



const MyReward = (props) => {
	const { points, availableCodeCount } = props.data;
	
	const {onClick, launcherFlag, email, visitorId} = props;

	return (
		<div id="my-reward" className="my-reward">

			<Header points={points} onClick={onClick} launcherFlag={launcherFlag} link="/" />
			<div className="panel-container with-wantdo-footer">
			
			{
				availableCodeCount === 0 ? 
				<EmptyMyReward />
				:
				<Lists email = {email} visitorId = {visitorId}/>
			}
			</div>
		</div>
	);
}

const Lists = (props) => {
	const [lists, setLists] = useState([]);
	const [loading, setLoading] = useState(true)
	const { email, visitorId } = props;
	
	useEffect(() => {
		getCodeLists(email).then((res)=> {
			const result = res.result;
			setLists(result);
			setLoading(false);
		}).catch((err)=>{
			console.log(err)
		})
		return () => {
			setLists([]);
			setLoading(true);
		}
	},[])

	const onToCouponCode = () => {
		trackSharePop(email, visitorId,  'discount-detail-page')
	}
	return (
		<div className="panel-subview">
			<div className="card-heading-container">
				<div className="card-title heading ">Your rewards</div>
			</div>
			{
					loading === true ?
					<Loading />
					:
					<div className="card-list-container mx-1">
					{
						
							lists.length > 0 ? lists.map((item, key)=> {
								return (
									<div className="card-list-item-container no-images" key={item.id}>
									<Link to={`/coupon-code?id=${item.id}`} onClick={ onToCouponCode }>
										<button className="card-list-item " aria-label={item.coupon}>
											<div className="card-list-item-content">
											{GIFT_CARD_SVG}
											<div className="list-item-text-wrapper">
													<div className="list-item-title">{item.coupon}</div>
													<div className="list-item-subtitle text-muted">{item.points}</div>
												</div>
											</div>
											{
												item.useFlag === "false" ? '' : <div style={{color: '#000'}}>Used</div>
											}
											<div className="chevron right">
											{RIGHT_SVG}
											</div>
										</button>
									</Link>
								</div>
								)
							})
							:
							<EmptyMyReward />
						}
				</div>
				
			}
				
		</div>
	)
}

export default MyReward;